import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import './styles.css';
import SchoolProfile from './SchoolProfile';
import AcademicMatch from './AcademicMatch';
import MediaCarousel from '../../components/MediaCarousel';
import PodBanner from '../../components/PodBanner';
import CollegeEvents from '../OverviewMenu/CollegeEvents';
import AvgNetPrice from '../CostsMenu/AvgNetPrice';
import GraduationRate from './GraduationRate';
import AcceptanceRate from '../AdmissionsMenu/AcceptanceRate';
import Deadline from '../shared/Deadline';
import Overlaps from './Overlaps';
import ContactInfo from './ContactInfo';
import RepVisits from '../OverviewMenu/RepVisists';
import CounselorComments from '../OverviewMenu/CounselorComments';
import YouVisitBanner from './YouVisitBanner';
import TrackingYouVisitBanner from './TrackingYouVisitBanner';
import withHostContext, { trackView, trackClick } from '../../context/host/consumer';
import {
  PERMISSIONS_COLLEGE_EVENTS,
  PERMISSIONS_COLLEGE_STATISTICS,
  PERMISSIONS_COLLEGE_VISITS,
  PERMISSIONS_COLLEGE_OVERLAPS,
  PERMISSION_SCHOLARSHIP_MATCH,
} from '../../constants';

// camino-only pods
import TotalUndergraduateEnrollment from './TotalUndergraduateEnrollment';
import TransferUndergraduateEnrollment from './TransferUndergraduateEnrollment';
import TransferScholarshipsAvailable from './TransferScholarshipsAvailable';
import TransferApplicationDeadline from './TransferApplicationDeadline';
import MeritBasedScholarship from './MeritBasedScholarship';

class OverviewMenu extends React.PureComponent {
  static propTypes = {
    collegeData: PropTypes.shape({
      ipedscode: PropTypes.string,
      logo: PropTypes.string,
      profile: PropTypes.object,
      webTour: PropTypes.object,
      webLink: PropTypes.object,
      fullProfile: PropTypes.object,
    }),
    isEnhanced: PropTypes.bool,
    userData: PropTypes.object,
    highSchool: PropTypes.object,
    collegeContact: PropTypes.array,
    sendEmail: PropTypes.func,
    overlaps: PropTypes.object,
    session: PropTypes.object,
    apiUrl: PropTypes.string,
    scid: PropTypes.number,
    isEditMode: PropTypes.bool,
    applicationStatistics: PropTypes.object,
    clickTrackingEvents: PropTypes.func,
    permissions: PropTypes.object,
    testScores: PropTypes.arrayOf(PropTypes.object),
    featureFlags: PropTypes.object,
  };

  render() {
    const {
      collegeData,
      isEnhanced,
      userData,
      collegeContact,
      overlaps,
      sendEmail,
      apiUrl,
      session,
      isEditMode,
      fetchCollegeEvents,
      applicationStatistics,
      scid,
      visits,
      highSchool,
      clickTrackingEvents,
      fetchCounselorComments,
      permissions,
      featureFlags,
      hostContext,
      testScores,
    } = this.props;

    const showAcademicMatch = get(permissions, 'colleges', []).includes(
      PERMISSIONS_COLLEGE_STATISTICS,
    );
    const showVisits = get(permissions, 'colleges', []).includes(
      PERMISSIONS_COLLEGE_VISITS,
    );
    const showEvents = get(permissions, 'colleges', []).includes(
      PERMISSIONS_COLLEGE_EVENTS,
    );
    const showOverlaps = get(permissions, 'colleges', []).includes(
      PERMISSIONS_COLLEGE_OVERLAPS,
    );
    const showScholarship = get(permissions, 'colleges', []).includes(
      PERMISSION_SCHOLARSHIP_MATCH,
    );
    const hubsWebTourPpid = get(collegeData, 'webTour.campus_media.product_id', null);
    const hubsWebTour = get(collegeData, 'webTour.campus_media.assets', []);
    const profiles = get(collegeData, 'profile.custom_profiles', []);
    const fullProfile = get(collegeData, 'fullProfile', {});
    const graduationRate4 = get(collegeData, 'fullProfile.studies.graduationRate4.value');
    const graduationRate6 = get(collegeData, 'fullProfile.studies.graduationRate6.value');
    const deadline = get(collegeData, 'fullProfile.admissions.deadlines[0]', {});
    const isCamino = get(hostContext, 'isCamino', false);
    const studentLife = get(collegeData, 'fullProfile.studentLife');
    const transferAdmissions = get(collegeData, 'fullProfile.transferAdmissions');
    const ipedscode = get(collegeData, 'ipedscode', null);

    const youVisitToursEnabledForNaviance = get(
      featureFlags,
      'featureMatchHubsYouVisitTours',
    );
    const youVisitToursEnabledForIntersect = get(
      featureFlags,
      'featureMatchHubsIntersectYouVisitTours',
    );
    const youVisitToursEnabled =
      youVisitToursEnabledForNaviance || youVisitToursEnabledForIntersect;
    const isClickTrackingEnabled = !!get(
      featureFlags,
      'featureMatchHubsYouVisitToursClickTracking',
    );

    return (
      <div className="overview-menu-container common-full-width">
        {(isEditMode || hubsWebTourPpid) && (
          <MediaCarousel
            productId={hubsWebTourPpid}
            media={hubsWebTour}
            isEditMode={isEditMode}
            featureFlags={featureFlags}
          />
        )}
        {isEnhanced && youVisitToursEnabled && !isClickTrackingEnabled && ipedscode && (
          <YouVisitBanner {...{ ipedscode }} />
        )}
        {isEnhanced && youVisitToursEnabled && isClickTrackingEnabled && ipedscode && (
          <TrackingYouVisitBanner {...{ ipedscode, scid, trackClick, trackView }} />
        )}
        <PodBanner>
          {isCamino && (
            <React.Fragment>
              <TotalUndergraduateEnrollment studentLife={studentLife} />
              <TransferUndergraduateEnrollment transferAdmissions={transferAdmissions} />
            </React.Fragment>
          )}
          <AvgNetPrice
            isCamino={isCamino}
            averageNetPrices={get(fullProfile, 'costs.averageNetPrices', {})}
            lastUpdated={get(fullProfile, 'costs.lastUpdated.value', '')}
          />
          {isCamino ? (
            <React.Fragment>
              <TransferScholarshipsAvailable transferAdmissions={transferAdmissions} />
              <TransferApplicationDeadline transferAdmissions={transferAdmissions} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              {
                /* istanbul ignore next */ showScholarship &&
                  get(featureFlags, 'releaseSharedScholarships') && (
                    <MeritBasedScholarship
                      scholarships={get(collegeData, 'fullProfile.scholarships', {})}
                      lastUpdated={get(fullProfile, 'costs.lastUpdated.value', '')}
                      userData={userData}
                      applicationStatistics={applicationStatistics}
                      testScores={testScores}
                      highSchool={highSchool}
                    />
                  )
              }
              <GraduationRate
                graduationRate4={graduationRate4}
                graduationRate6={graduationRate6}
                lastUpdated={get(collegeData, 'fullProfile.admissions.lastUpdated.value')}
              />
              <AcceptanceRate
                acceptanceRate={get(collegeData, 'fullProfile.admissions.acceptanceRate')}
                lastUpdated={get(
                  collegeData,
                  'fullProfile.admissions.lastUpdated.value',
                  '',
                )}
              />
              {showOverlaps && <Overlaps overlaps={overlaps} />}
              <Deadline {...deadline} featureFlags={featureFlags} />
            </React.Fragment>
          )}
        </PodBanner>
        <CounselorComments fetchCounselorComments={fetchCounselorComments} />
        {showVisits && (
          <RepVisits
            collegeData={collegeData}
            scid={scid}
            userData={userData}
            visits={visits}
            highschool={highSchool}
          />
        )}
        {showEvents && (
          <CollegeEvents
            collegeData={collegeData}
            fetchCollegeEvents={fetchCollegeEvents}
            clickTrackingEvents={clickTrackingEvents}
            scid={scid}
            userData={userData}
          />
        )}
        <SchoolProfile
          schoolProfile={
            /* istanbul ignore next */ profiles
              ? profiles.find((p) => p && p.type === 'school')
              : null
          }
          fullProfile={fullProfile}
        />
        {
          /* istanbul ignore next */ showAcademicMatch && (
            <AcademicMatch
              userData={userData}
              fullProfile={fullProfile}
              apiUrl={apiUrl}
              session={session}
              scid={scid}
              applicationStatistics={applicationStatistics}
              highSchool={highSchool}
              featureFlags={featureFlags}
              testScores={testScores}
            />
          )
        }
        <ContactInfo
          overviewData={get(collegeData, 'fullProfile.overview', {})}
          premium_links={get(collegeData, 'webLink.premium_links', [])}
          userData={userData}
          collegeContact={collegeContact}
          sendEmail={sendEmail}
          isCamino={isCamino}
        />
      </div>
    );
  }
}

export default withHostContext(OverviewMenu);
